import { garconClient } from "@apis/axiosClients"
import { toast } from "sonner"

export const getCase = async (caseGuid, callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/cases/${caseGuid}/view`,
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const createCase = async (caseForm) => {
  try {
    const response = await garconClient.post(
      `${import.meta.env.VITE_GARCON_API}/cases`,
      caseForm,
    )
    if (response.status === 200) {
      toast.success(`Case created! Case Guid: ${response?.data.case_guid}`)
      return response?.data
    }
  } catch (error) {
    toast.error(`Unable to create case: ${error}`)
    throw error
  }
}

export const getCaseAttributes = async (caseGuid) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/cases/${caseGuid}/attributes`,
    )
    return response?.data
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const getAddressFromAttribute = async (addressGuid, callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/addresses/${addressGuid}`,
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}
